import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { Link } from 'react-router-dom';
import { useMultiTabLogout } from '../../../../../common/hooks/useMultiTabLogout';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { resources } from '../../../resources/resources';

export default function UserMenu() {
  const { t: translate } = useTranslation();
  const auth = useAuth();
  const { triggerLogout } = useMultiTabLogout();
  const { customerInfo } = useContext(CustomerInfoContext);

  const handleLogout = async () => {
    triggerLogout();
    await auth.signoutRedirect();
  };

  return (
    <ul>
      {!customerInfo.isSavingsUser && (
        <li>
          <Link to="/my-account/dashboard">
            {translate(resources.menu.dashboard)}
          </Link>
        </li>
      )}
      {(customerInfo.canAccessMyBenefits ||
        customerInfo.canAccessExclusive ||
        customerInfo.canAccessSubscriptions) && (
        <li>
          <Link to="/my-account/my-benefits">
            {translate(resources.menu.myBenefits)}
          </Link>
        </li>
      )}
      {!customerInfo.isSavingsUser &&
        customerInfo.canAccessTimeAndAttendanceModule && (
          <li>
            <Link to="/my-account/time-and-attendance">
              {translate(resources.menu.timeAndAttendance)}
            </Link>
          </li>
        )}
      <li>
        <Link to="/my-account/orders">{translate(resources.menu.orders)}</Link>
      </li>
      {customerInfo.canAccessSubscriptions && (
        <li>
          <Link to="/my-account/subscriptions">
            {translate(resources.menu.subscriptions)}
          </Link>
        </li>
      )}
      {!customerInfo.isSavingsUser && (
        <li>
          <Link to="/my-account/notifications">
            {customerInfo.notificationsCount > 0 && (
              <span className="alerts-count-menu">
                <span>{customerInfo.notificationsCount}</span>
              </span>
            )}
            {translate(resources.menu.notifications)}
          </Link>
        </li>
      )}
      <li>
        <Link to="/my-account/vouchers">
          {translate(resources.menu.vouchers)}
        </Link>
      </li>
      {!customerInfo.isSavingsUser && customerInfo.canAccessMyCards && (
        <li>
          <Link to="/my-account/cards">{translate(resources.cards)}</Link>
        </li>
      )}
      <li>
        <Link to="/my-account/preferences">
          {translate(resources.menu.userPreferences)}
        </Link>
      </li>
      <li>
        <Link to="/my-account/account-info">
          {translate(resources.menu.accountInfo)}
        </Link>
      </li>
      {!customerInfo.isSavingsUser && (
        <li>
          <Link to="/my-account/change-password">
            {translate(resources.menu.passwordChange)}
          </Link>
        </li>
      )}
      {!customerInfo.isSavingsUser && customerInfo.canGenerateDemoAccount && (
        <li>
          <Link to="/my-account/create-demo-account">
            {translate(resources.demoAccount.title)}
          </Link>
        </li>
      )}
      {!customerInfo.isSavingsUser && (
        <li>
          <button className="btn-link-menu-item" onClick={handleLogout}>
            {translate(resources.menu.logout)}
          </button>
        </li>
      )}
    </ul>
  );
}
